import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import RichTextInput from 'ra-input-rich-text'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import _ from 'lodash'
import {
  ArrayInput,
  FormDataConsumer,
  maxLength,
  NumberInput,
  ReferenceInput,
  required,
  SimpleFormIterator,
  TextInput,
  SelectInput,
  LongTextInput,
  REDUX_FORM_NAME,
} from 'react-admin'
import { AutocompleteInput } from '../../../../components/inputs'
import LanguagesNav from '../../../../components/languagesNav'
import { getResource } from '../../../../config/resources'
import { change } from 'redux-form'
import { Tab, Tabs } from '@material-ui/core'

const styles = {
  simpleFormIteratorStyle: {
    '& ul': {
      '& li': {
        '& > section': {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          '& > div': {
            flex: '1 0 auto',
            maxWidth: '220px',
            padding: '10px',
          },
        },
      },
    },
  },
  iteratorInput: {
    marginTop: '10px',
  },
}

const SelectQueryParam = ({ ...props }) => {
  const { choices, input, source, dispatch, change, ...rest } = props
  const { value, onChange } = props.input

  const newOnChange = (inputValue) => {
    const nameSource = _.replace(source, '.id', '')
    dispatch(change(REDUX_FORM_NAME, `${nameSource}.name`, _.find(choices, { id: inputValue }).name))
    onChange(inputValue)
  }

  const newInput = { ...input }
  newInput.onChange = newOnChange

  const newProps = { ...props }

  newProps.input = newInput

  return <SelectInput {...newProps} />
}

const AssistanceForm = ({ classes }) => {
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={6}>
        <NumberInput validate={[required()]} label="Assistance" source="config.attendance.current" step={1} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <NumberInput validate={[required()]} label="Previous assistance" source="config.attendance.previous" step={1} fullWidth />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <LongTextInput label="Season ES" source="config.season_es" fullWidth toolbar={[[]]} />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <LongTextInput label="Season EN" source="config.season_en" fullWidth toolbar={[[]]} />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <LongTextInput label="Note ES" source="config.note_es" fullWidth toolbar={[[]]} />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <LongTextInput label="Note EN" source="config.note_en" fullWidth toolbar={[[]]} />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <div className={classes.simpleFormIteratorStyle}>
          <ArrayInput source="config.attendance.previous_season" label="Previous seasons">
            <SimpleFormIterator className={classes.SimpleFormIteratorStyle} classes={classes} fullWidth>
              <TextInput validate={[required()]} label="Season" source="season" fullWidth />
              <NumberInput validate={[required()]} label="Percentage" source="percentage" fullWidth />
              <NumberInput validate={[required()]} label="Number" source="number" step={1} fullWidth />
            </SimpleFormIterator>
          </ArrayInput>
        </div>
      </Grid>
    </Grid>
  )
}
const OccupationForm = ({ classes }) => {
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={6}>
        <NumberInput validate={[required()]} label="Occupation" source="config.occupation.current" step={1} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <NumberInput validate={[required()]} label="Difference (pp)" source="config.occupation.difference" step={1} fullWidth />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <div className={classes.simpleFormIteratorStyle}>
          <ArrayInput source="config.occupation.previous_season" label="Previous seasons">
            <SimpleFormIterator className={classes.SimpleFormIteratorStyle} classes={classes} fullWidth>
              <TextInput validate={[required()]} label="Season" source="season" fullWidth />
              <NumberInput label="Percentage (pp)" source="difference" fullWidth />
              <NumberInput label="Number" source="number" step={1} fullWidth />
            </SimpleFormIterator>
          </ArrayInput>
        </div>
      </Grid>
    </Grid>
  )
}

export class ModuleForm extends Component {
  state = {
    value: 'Assistance',
  }

  handleChange = (event, value) => {
    this.setState({ value })
  }
  render() {
    const { classes } = this.props
    return (
      <LanguagesNav {...this.props} removeDelete disabledLanguages>
        <FormDataConsumer>
          {({ formData, dispatch, ...rest }) => (
            <Grid container>
              <Grid container>
                <Grid item xs={12} sm={6} md={4}>
                  <TextInput fullWidth label="Name" source="name" validate={[required(), maxLength(255)]} />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={6} md={4}>
                  <ReferenceInput label="Digital asset" source="digitalAssetId" reference={getResource('digitalAssets', 'digital-assets')}>
                    <AutocompleteInput fullWidth />
                  </ReferenceInput>
                </Grid>
              </Grid>
              <ArrayInput source="queryParams">
                <SimpleFormIterator>
                  <ReferenceInput className={classes.iteratorInput} label="Name" source="id" reference={getResource('layouts', 'queryParams')}>
                    <SelectQueryParam dispatch={dispatch} change={change} />
                  </ReferenceInput>
                </SimpleFormIterator>
              </ArrayInput>
              {formData && formData.slug === 'modulo-asistencia' && (
                <Paper>
                  <Tabs value={this.state.value} onChange={this.handleChange} fullWidth indicatorColor="primary" textColor="primary">
                    <Tab value="Assistance" label="Assistance" />
                    <Tab value="Occupation" label="Occupation" />
                  </Tabs>
                  {this.state.value === 'Assistance' && <AssistanceForm classes={classes} />}
                  {this.state.value === 'Occupation' && <OccupationForm classes={classes} />}
                </Paper>
              )}
            </Grid>
          )}
        </FormDataConsumer>
      </LanguagesNav>
    )
  }
}

const enhance = compose(
  connect(
    (state) => ({
      //field: source => selector(state, source)
    }),
    (dispatch) => ({
      change: (form, field, value) => dispatch(change(form, field, value)),
    })
  ),
  withStyles(styles)
)

export default enhance(ModuleForm)
